module.exports = __webpack_public_path__ + "static/media/B_S01.e969c7b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GREEN/B_S01.png
// module id = 91
// module chunks = 0